import { appConfig } from '../../config';
import { LocalStorage } from '../bridges/local-storage.bridge';
import { LocalStorageKeys } from '../constants/local-storage.constants';

class StorageService {
  init() {
    /* useful when we need to drop local storage from current users for some reason */
    const clearCounter = LocalStorage.get(LocalStorageKeys.LSClearCounter);
    if (clearCounter < appConfig.clearLSCounter) {
      localStorage.clear();
      LocalStorage.set(
        LocalStorageKeys.LSClearCounter,
        appConfig.clearLSCounter,
      );
      window.location.reload();
    }
  }
}

export const storageService = new StorageService();
